import React from 'react';
import { NavLink } from 'react-router-dom';
import '../assets/styles/components/RoutesMenu.sass';

const RoutesMenu5Stages = ({year}) => (
  <div className="row routes-menu">
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <ul className="routes-menu__list">
            <li className="routes-menu__list--item">
              <NavLink id="stageResumen" to={`/route/${year}/summary`}>
                SUMMARY
              </NavLink>
            </li>
            <li className="routes-menu__list--item">
              <NavLink id="stageEtapa1" to={`/route/${year}/stage-one`}>
                STAGE 1
              </NavLink>
            </li>
            <li className="routes-menu__list--item">
              <NavLink id="stageEtapa2" to={`/route/${year}/stage-two`}>
                STAGE 2
              </NavLink>
            </li>
            <li className="routes-menu__list--item">
              <NavLink id="stageEtapa3" to={`/route/${year}/stage-three`}>
                STAGE 3
              </NavLink>
            </li>
            <li className="routes-menu__list--item">
              <NavLink id="stageEtapa4" to={`/route/${year}/stage-four`}>
                STAGE 4
              </NavLink>
            </li>
            <li className="routes-menu__list--item">
              <NavLink id="stageEtapa5" to={`/route/${year}/stage-five`}>
                STAGE 5
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)
  
export default RoutesMenu5Stages;